module.exports = __webpack_public_path__ + "static/media/networkCenterImg2.87483cce.png";